import * as moment from 'moment';

export class DailyTripFilter {
    tripDate?: string; // mm/dd/yyyy
    clientId?: number;
    tripId?: number;
    driverId?: number;
    helperId?: number;
    bookKeeperId?: number;
    containerNumber?: string;
    tripDateFrom?: string;
    tripDateTo?: string;
    vehicleId?: number;
    shippingLineId?: number;
    returnDestination?: string;
    dailyTripTypeId?: number;


    createdDate?: string; // mm/dd/yyyy
    // createdBy: number;
    // updatedDateString: string;
    // updatedBy: number;

    constructor() {
        this.tripDate = null;
        this.tripDateFrom = moment().subtract(1, 'days').format('YYYY/MM/DD');        
        this.tripDateTo = moment().format('YYYY/MM/DD');
    }
}



// WEBPACK FOOTER //
// ./src/app/models/trips/dailyTripFilter.ts